import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

// Accept minHeight as a prop
const LoadingContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "minHeight",
})<{ minHeight?: string | number }>(({ theme, minHeight }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: minHeight || "100vh", // Use prop or default
  backgroundColor: theme.palette.background.default,
}));

const StyledCircularProgress = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.primary.main,
  marginBottom: theme.spacing(2),
}));

const LoadingText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  marginTop: theme.spacing(1),
  fontSize: theme.spacing(2),
}));

interface LoadingSpinnerProps {
  message?: string;
  minHeight?: string | number;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = "Loading...",
  minHeight,
}) => {
  return (
    <LoadingContainer minHeight={minHeight}>
      <StyledCircularProgress size={60} thickness={4} />
      {message && <LoadingText variant="h6">{message}</LoadingText>}
    </LoadingContainer>
  );
};

export default LoadingSpinner;
